import type { IIdentifierDeclaration } from '../interfaces/identifierDeclaration';

export function hasValidAgbCode(practitioner: IIdentifierDeclaration) {
    return (
        !!practitioner.identifierDeclaration &&
        (practitioner.identifierDeclaration.startsWith('010') ||
            practitioner.identifierDeclaration.startsWith('011') ||
            practitioner.identifierDeclaration.startsWith('03') ||
            practitioner.identifierDeclaration.startsWith('12') ||
            practitioner.identifierDeclaration.startsWith('14') ||
            (practitioner.identifierDeclaration.startsWith('84') && Boolean(practitioner.hasDeclarableQualification)))
    );
}
